export default __webpack_public_path__ + "60edb53b76ec92cc6cafbfb14bf6fab0.jpg";